'use client'

import { useEffect, useState } from 'react'
import { getApiBaseUrl } from '@/lib/config'
import type { MarketHistoryRange, MarketInstrumentKey } from '@/lib/market-rates'

export type MarketHistoryPoint = {
  t: string
  rate: number
  changePct?: number | null
}

export function useMarketHistory(code: MarketInstrumentKey, range: MarketHistoryRange) {
  const [points, setPoints] = useState<MarketHistoryPoint[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    async function load() {
      try {
        setLoading(true)
        setError(null)
        const res = await fetch(
          `${getApiBaseUrl()}/api/market/history?code=${encodeURIComponent(code)}&range=${encodeURIComponent(range)}`,
          { cache: 'no-store' },
        )
        if (!res.ok) throw new Error('history fetch failed')
        const json = await res.json()
        if (cancelled) return
        const list = Array.isArray(json?.data?.points) ? json.data.points : []
        setPoints(list)
      } catch {
        if (cancelled) return
        setPoints([])
        setError('Grafik verisi yüklenemedi')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    void load()
    return () => {
      cancelled = true
    }
  }, [code, range])

  return { points, loading, error }
}
